import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule, NgOptimizedImage } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { EnableForRolesDirective } from './directives/enable-for-roles.directive';
import { DisableForRolesDirective } from './directives/disable-for-roles.directive';
import { ComponentsModule } from '../../../common-modules/components/components.module';
import { DirectivesModule } from '../../../common-modules/directives/directives.module';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SignupComponent } from './components/signup/signup.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { TcDialogComponent } from './components/tc-dialog/tc-dialog.component';
import { PipesModule } from '../../../common-modules/pipes/pipes.module';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { SigninComponent } from './components/signin/signin.component';
import { QrDialogComponent } from './components/qr-dialog/qr-dialog.component';
import { QrCodeModule } from 'ng-qrcode';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { DiscoveryComponent } from './components/discovery/discovery.component';

// import { RecaptchaModule } from 'ng-recaptcha';

@NgModule({
    declarations: [
        EnableForRolesDirective,
        DisableForRolesDirective,
        SignupComponent,
        SigninComponent,
        TcDialogComponent,
        MaintenanceComponent,
        QrDialogComponent,
        ResetPasswordComponent,
        ForgotPasswordComponent,
        DiscoveryComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AuthRoutingModule,
        ComponentsModule,
        DirectivesModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatSelectModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatProgressBarModule,
        MatDialogModule,
        PipesModule,
        NgOptimizedImage,
        QrCodeModule,
        MatProgressSpinner,
        // RecaptchaModule,
    ],
    exports: [EnableForRolesDirective, DisableForRolesDirective],
})
export class AuthModule {}
